'use strict';

var Classnames = require('classnames');
var React = require('react');
var Reflux = require('reflux');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./input.scss');
}

var Store = require('../store');

var Input = React.createClass({
    propTypes: {
        // reflux store key
        keyname: React.PropTypes.string.isRequired,

        // html label
        label: React.PropTypes.string,

        // autocomplete attribute
        autocomplete: React.PropTypes.string,

        // not a simple store key - use a function to get/set instead
        source: React.PropTypes.func,
        action: React.PropTypes.func,

        // red border if edited and still empty
        required: React.PropTypes.bool,

        // show red border anyway
        alert: React.PropTypes.bool,

        type: React.PropTypes.string,

        // Show label and placeholder or not
        showLabel: React.PropTypes.bool,
        showPlaceholder: React.PropTypes.bool,
    },
    mixins: [
        Reflux.listenTo(Store.Store, 'onStoreChange', 'onStoreChange')
    ],
    onStoreChange: function(store) {
        var v;
        if (typeof this.props.source === 'undefined') {
            v = store.fields[this.props.keyname] || '';
        } else {
            v = this.props.source();
        }
        this.setState({
            value: v,
            stored: v,
        });
    },
    getDefaultProps: function() {
        return {
            type: 'text',
            showLabel: true,
            showPlaceholder: true,
        }
    },
    getInitialState: function() {
        return {
            value: '',
            tagId: 'mux_' + this.props.keyname,
            isEditing: false,
            hasEdited: false
        };
    },

    save: function() {
        if (typeof this.props.action === 'undefined') {
            Store.Actions.setProjectField(this.props.keyname, this.state.value);
        } else {
            this.props.action(this.state.value);
        }
    },
    
    handleFocus: function(event) {
        this.setState({
            isEditing: true,
        });
    },
    handleChange: function(event) {
        this.setState({ value: event.target.value });
    },
    handleKeyUp: function(event) {
        if (event.which === 13) {  // enter
            this.refs.input.blur();
        }
        else if (event.which === 27) { // escape
            this.setState({
                isEditing: false,
                value: this.state.stored,
            }, function() {  // prevent saving
                this.refs.input.blur();
            });
        }
    },
    handleBlur: function(ev) {
        if (this.state.isEditing) {  // enter or blur, not escape
            this.save()
        }
        this.setState({
            hasEdited: true,
            isEditing: false,
        });
    },
    render: function() {
        var label;
        if (this.props.label) {
            label = (
                <label htmlFor={this.state.tagId}>
                    {this.props.label}
                </label>
            );
        }
        var classes = Classnames({
            'forms-control': true,
            'forms-control-requiredLabel': !this.state.value && (this.props.alert || (this.props.required && this.state.hasEdited))
                || (this.state.value && typeof this.props.validator === 'function' && !this.props.validator(this.state.value)),
            // no value, and either global alert, or required and already edited
            // or has value, and validator function returns false
        });
        return (
            <div className='input'>
                {this.props.showLabel ?
                    label
                : null}
                <div className={classes}>
                    <input ref          = 'input'
                           type         = {this.props.type}
                           id           = {this.state.tagId}
                           name         = {this.props.keyname}
                           value        = {this.state.value}
                           /*autoComplete = {this.props.autocomplete}*/
                           autoComplete = 'nope'  /* confuse Chrome to disable autocomplete which is auto-incompatible with React controlled inputs */
                           onChange     = {this.handleChange}
                           onKeyUp      = {this.handleKeyUp}
                           onFocus      = {this.handleFocus}
                           onBlur       = {this.handleBlur}
                           placeholder  = {this.props.showPlaceholder ? this.props.placeholder : null}
                           className    = 'mux-input' />
                </div>
            </div>
        );
    }
});

module.exports = Input;



// WEBPACK FOOTER //
// ./src/forms/input.jsx